import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/inventories";
export const useInventories = () => {
    const [inventories, setInventories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAll = useCallback(async (filter) => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            if (filter) {
                params.set("filter", JSON.stringify(filter));
            }
            params.set("offset", "0");
            params.set("limit", "200");
            const res = await getAxios().get(`${endpoint}?${params.toString()}`);
            setInventories(res.data);
        }
        catch (err) {
            setError(err.message || "Failed to fetch inventories.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = useCallback(async (payload) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll();
        return res.data;
    }, [fetchAll]);
    const update = useCallback(async (uuid, payload) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    }, [fetchAll]);
    const patch = useCallback(async (uuid, payload) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    }, [fetchAll]);
    const remove = useCallback(async (uuid) => {
        const res = await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll();
        return res.data;
    }, [fetchAll]);
    const checkName = useCallback(async (name) => {
        const res = await getAxios().get(`${endpoint}/check-name`, {
            params: { name },
        });
        return res.data;
    }, []);
    return { inventories, loading, error, fetchAll, create, update, patch, remove, checkName };
};
